// components/Intro.js
import React from 'react';
import './Intro.css';

function Intro() {
  const scrollToWaitlist = () => {
    const waitlistSection = document.getElementById('waitlist-section');
    if (waitlistSection) {
      waitlistSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { value: '10×', label: 'Cheaper Storage' },
    { value: '1B+', label: 'Vectors per Node' },
    { value: '100%', label: 'Postgres Compatible' },
  ];

  return (
    <section className="intro">
      <div className="intro__glow" />
      <div className="hero-content">
        <p className="hero-eyebrow">S3-Backed Storage Engine for Postgres</p>
        <h1>
          <span className="hero-gradient-text">Bottomless Postgres</span>
          {' '}for AI
        </h1>
        <p className="sub-headline">
          Store trillions of embeddings on S3. Query them with SQL. Scale without limits.
        </p>
        <div className="hero-stats">
          {stats.map((stat, i) => (
            <div key={i} className="hero-stat">
              <span className="hero-stat__value">{stat.value}</span>
              <span className="hero-stat__label">{stat.label}</span>
            </div>
          ))}
        </div>
        <div className="cta-section">
          <button className="cta-button" onClick={scrollToWaitlist}>
            Join the Waitlist
          </button>
          <p className="cta-subtext">Be the first to get early access & special pricing.</p>
        </div>
      </div>
    </section>
  );
}

export default Intro;
